import { ORDER_EXPERIENCES } from '@ordersnproducts/modules/shared/constants/order-experiences';
import { SHIPPING_CONDITION_CODE } from '../../../../../../shared/constants/shipping-conditions-codes';
import { RMS_UL } from './delivery/rms-ul.config';

export const readymix = {
  [SHIPPING_CONDITION_CODE.DELIVERY]: {
    [ORDER_EXPERIENCES.RMX_UNIVERSAL_LINK]: RMS_UL,
  },
};
